import React from 'react';
import { FaTimes, FaEye, FaDownload } from 'react-icons/fa';
import logo from '../../assets/Images/LOGOS/Docity_Logo.png';

const MarketValueCertificateModal = ({ isOpen, onClose, certificateData, onViewFullCertificate }) => {
    if (!isOpen || !certificateData) return null;

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        });
    };

    const generateCertificateNumber = () => {
        const timestamp = Date.now().toString(36).toUpperCase();
        const random = Math.random().toString(36).substr(2, 8).toUpperCase();
        return `MVDC-${timestamp}-${random}`;
    };

    const certificateNumber = generateCertificateNumber();
    const currentDate = new Date().toLocaleDateString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });

    return (
        <div className="mvec-modal-overlay" onClick={onClose}>
            <div className="mvec-modal-content" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="mvec-modal-header">
                    <button className="mvec-close-btn" onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>
                {/* Certificate Preview */}
                <div className="mvec-certificate-container">
                    {/* Decorative Top Border */}
                    <div className="mvec-cert-top-border" />

                    {/* Header */}
                    <div className="mvec-cert-header">
                        <img src={logo} alt="Docity Logo" className="mvec-cert-logo" />
                        <div className="mvec-cert-header-text">
                            <h1 className="mvec-cert-title">Market Value Declaration</h1>
                            <p className="mvec-cert-subtitle">Certificate of Verification</p>
                        </div>
                    </div>

                    {/* Certificate Number */}
                    <div className="mvec-cert-number">
                        <span>Certificate No. : {certificateNumber}</span>
                        <span>Date : {currentDate}</span>
                    </div>

                    {/* Divider */}
                    <div className="mvec-cert-divider" />

                    {/* Main Content */}
                    <div className="mvec-cert-content">
                        {/* Property Details Grid */}
                        <div className="mvec-details-grid">
                            <div className="mvec-detail-item">
                                <label className="mvec-detail-label">Registration Document Number</label>
                                <p className="mvec-detail-value">{certificateData.registrationDocNumber}</p>
                            </div>

                            <div className="mvec-detail-item">
                                <label className="mvec-detail-label">Registration Date</label>
                                <p className="mvec-detail-value">{formatDate(certificateData.registrationDate)}</p>
                            </div>

                            <div className="mvec-detail-item">
                                <label className="mvec-detail-label">Market Value Amount</label>
                                <p className="mvec-detail-value">
                                    {certificateData.marketValue} {certificateData.currency}
                                </p>
                            </div>

                            <div className="mvec-detail-item">
                                <label className="mvec-detail-label">Declaration Date</label>
                                <p className="mvec-detail-value">{currentDate}</p>
                            </div>
                        </div>

                        {/* Verification Statement */}
                        <div className="mvec-verification-box">
                            <p className="mvec-verification-text">
                                The undersigned hereby declares that the above market value details are true, accurate, and complete to the best of their knowledge. This certificate is issued for property valuation and official record purposes.
                            </p>
                        </div>

                        {/* Footer Seal */}
                        <div className="mvec-cert-seal">
                            <div className="mvec-seal-circle">
                                <span className="mvec-seal-text">CERTIFIED</span>
                                <span className="mvec-seal-date">{currentDate}</span>
                            </div>
                        </div>
                    </div>

                    {/* Decorative Bottom Border */}
                    <div className="mvec-cert-bottom-border" />

                    {/* Footer */}
                    <div className="mvec-cert-footer">
                        <p className="mvec-footer-text">
                            This certificate is digitally verified and issued by Docity. For verification, please reference the certificate number above.
                        </p>
                    </div>
                </div>

                {/* Actions */}
                <div className="mvec-actions">
                    <button className="mvec-btn mvec-btn-secondary" onClick={onClose}>
                        Close
                    </button>
                    <button className="mvec-btn mvec-btn-primary" onClick={onViewFullCertificate}>
                        <FaDownload /> View & Download Certificate
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MarketValueCertificateModal;
